import * as actions from "./account.balance.actions";
import produce from "immer";
import moment from "moment";

const today = new Date();

let currencyInitData = {
  data: {},
  fetching: false,
  fetched: false,
  lsFetched: false,
  lsFetching: false,
  lsData: {},
  error: null,
  originatorsFetched: false,
  originatorsFetching: false,
  originatorsData: {},
};

let initialState = {
  selectedDate: null,
  fromDate: moment(today).subtract(7, "days").toDate(),
  toDate: moment(today).add(1, "days").toDate(),
  SEK: currencyInitData,
  EUR: currencyInitData,
};

const accountBalance = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case actions.TRUSTLY_ACCOUNT_BALANCE_FETCH_REQUEST:
        draft[action.additionalData.Currency].trustlyFetching = true;
        break;
      case actions.TRUSTLY_ACCOUNT_BALANCE_FETCH_SUCCESS:
        draft[action.additionalData.Currency].trustlyFetched = true;
        draft[action.additionalData.Currency].trustlyFetching = false;
        draft[action.additionalData.Currency].trustlyData =
          action.response.find(
            (b) => b.Currency === action.additionalData.Currency,
          )?.Balance;
        break;
      case actions.ACCOUNT_BALANCE_CHANGE_DATE:
        if (action.dateType == "From")
          return Object.assign({}, state, {
            fromDate: action.date,
          });
        else if (action.dateType == "To")
          return Object.assign({}, state, {
            toDate: action.date,
          });
        else if (action.dateType == "Selected")
          return Object.assign({}, state, {
            selectedDate: action.date,
          });
        else return state;

      default:
        return state;
    }
  });
};

export default accountBalance;
